import React from "react";
import VideoGrid from "../Components/Grid/VideoGrid";
import TagContainer from "../Components/Tags/TagContainer";
import Heading from "../Components/ui/Heading";
import Pagination from "../Components/ui/Pagination";
const Home = () => {
  return (
    <>
      <TagContainer />
      <Heading />
      <VideoGrid />
      <Pagination />
    </>
  );
};

export default Home;
